import { render, staticRenderFns } from "./StartShift.vue?vue&type=template&id=70e4817c&scoped=true&"
import script from "./StartShift.vue?vue&type=script&lang=js&"
export * from "./StartShift.vue?vue&type=script&lang=js&"
import style0 from "./StartShift.vue?vue&type=style&index=0&id=70e4817c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e4817c",
  null
  
)

export default component.exports